module.exports = __webpack_public_path__ + "img/4_img.706a5540.png";